// extracted by mini-css-extract-plugin
export default {"login":"PhAuth_login__8pkCb"};